{
  "title": "المجموعات",
  "description": "مجموعات الصلاحيات لمستخدمي لوحة التحكم والعمليات",
  "actions": {
    "add": "إضافة مجموعة"
  },
  "columns": {
    "name": "الاسم",
    "description": "الوصف",
    "users": "المستخدمون",
    "services": "الخدمات",
    "status": "الحالة"
  },
  "list": {
    "ariaLabel": "المجموعات",
    "searchPlaceholder": "البحث باسم المجموعة"
  },
  "systemGroupProtected": "لا يمكن تعديل أو حذف مجموعة مدير النظام",
  "rowActions": {
    "edit": "تعديل",
    "manageServices": "تعيين الخدمات",
    "activate": "تفعيل",
    "deactivate": "تعطيل",
    "delete": "حذف"
  },
  "drawer": {
    "createTitle": "إضافة مجموعة",
    "editTitle": "تعديل المجموعة",
    "fields": {
      "nameAr": "الاسم بالعربية",
      "nameEn": "الاسم بالإنجليزية",
      "descriptionAr": "الوصف بالعربية",
      "descriptionEn": "الوصف بالإنجليزية"
    },
    "submit": "حفظ",
    "cancel": "إلغاء",
    "discard": {
      "title": "تجاهل التغييرات؟",
      "description": "لن يتم حفظ ما أدخلته على هذه المجموعة.",
      "confirmLabel": "تجاهل",
      "cancelLabel": "متابعة التعديل"
    },
    "created": "تم إنشاء المجموعة بنجاح",
    "updated": "تم تحديث المجموعة بنجاح"
  },
  "statusConfirm": {
    "activateTitle": "تفعيل {{name}}؟",
    "activateDescription": "سيتمكن مستخدمو هذه المجموعة من تسجيل الدخول مجددا.",
    "deactivateTitle": "تعطيل {{name}}؟",
    "deactivateDescription": "لن يتمكن مستخدمو هذه المجموعة من تسجيل الدخول حتى تتم إعادة تفعيلها.",
    "confirmActivate": "تفعيل",
    "confirmDeactivate": "تعطيل"
  },
  "deleteConfirm": {
    "title": "حذف {{name}}؟",
    "description": "سيتم حذف هذه المجموعة نهائيا. هذا الإجراء لا يمكن التراجع عنه.",
    "confirm": "حذف"
  },
  "services": {
    "title": "خدمات {{group}}",
    "description": "الخدمات التي تمنحها المجموعة. اختيار إجراء يحدد خدمتي العرض والقائمة تلقائيا.",
    "autoAddedNote": "محددة تلقائيا لأن خدمة أخرى على نفس العنصر مفعلة",
    "selectAll": "تحديد الكل",
    "deselectAll": "إلغاء تحديد الكل",
    "searchPlaceholder": "بحث عن خدمة",
    "platformAccessTitle": "تفتح هذه المجموعة:",
    "platformOperator": "بطاقة العمليات (Operator)",
    "platformDashboard": "بطاقة لوحة التحكم (Dashboard)",
    "platformNone": "لا تفتح أي بطاقة حاليا",
    "save": "حفظ الخدمات",
    "saved": "تم حفظ الصلاحيات بنجاح",
    "systemGroupNotice": "صلاحيات مجموعة مدير النظام ثابتة ولا يمكن تعديلها",
    "discard": {
      "title": "تجاهل التغييرات؟",
      "description": "لن يتم حفظ التغييرات التي أدخلتها على خدمات هذه المجموعة.",
      "confirmLabel": "تجاهل",
      "cancelLabel": "متابعة التعديل"
    },
    "platformPda": "بطاقة المحروقات - PDA"
  },
  "toasts": {
    "statusChanged": "تم تغيير حالة المجموعة بنجاح",
    "deleted": "تم حذف المجموعة بنجاح"
  }
}
